export const DAY_KEYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const;
export type DayKey = (typeof DAY_KEYS)[number];

export interface BusinessHourEntry {
  day: DayKey;
  open: boolean;
  hours: string;
}

export const DEFAULT_BUSINESS_HOURS: BusinessHourEntry[] = [
  { day: 'mon', open: true, hours: '9:00 AM - 6:00 PM' },
  { day: 'tue', open: true, hours: '9:00 AM - 6:00 PM' },
  { day: 'wed', open: true, hours: '9:00 AM - 6:00 PM' },
  { day: 'thu', open: true, hours: '9:00 AM - 6:00 PM' },
  { day: 'fri', open: true, hours: '9:00 AM - 6:00 PM' },
  { day: 'sat', open: true, hours: '10:00 AM - 4:00 PM' },
  { day: 'sun', open: false, hours: '' },
];

/** Ensures all 7 days are present, in mon..sun order, filling any missing day as closed. */
export function normalizeBusinessHours(raw: unknown): BusinessHourEntry[] {
  const byDay = new Map<DayKey, BusinessHourEntry>();
  if (Array.isArray(raw)) {
    for (const entry of raw) {
      const day = entry?.day;
      if (DAY_KEYS.includes(day)) {
        byDay.set(day, { day, open: !!entry.open, hours: entry.hours ?? '' });
      }
    }
  }
  return DAY_KEYS.map((day) => byDay.get(day) ?? { day, open: false, hours: '' });
}

export interface BusinessHourGroup {
  days: DayKey[];
  open: boolean;
  hours: string;
}

/** Collapses consecutive days that share the same open/hours state into one group. */
export function groupBusinessHours(entries: BusinessHourEntry[]): BusinessHourGroup[] {
  const groups: BusinessHourGroup[] = [];
  for (const entry of entries) {
    const last = groups[groups.length - 1];
    const sameAsLast = last && last.open === entry.open && (!entry.open || last.hours === entry.hours);
    if (sameAsLast) {
      last.days.push(entry.day);
    } else {
      groups.push({ days: [entry.day], open: entry.open, hours: entry.hours });
    }
  }
  return groups;
}
